// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  Summary,
} from './';

export default {
  path: 'summary',
  name: 'Summary',
  childRoutes: [
    { path: 'summary', name: 'Summary', component: Summary, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/summary/route.js